// src/store/authSlice.ts
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { AuthProviderType as Provider } from "../config";

type AuthProviderType = Provider | null;

interface AuthState {
  provider: AuthProviderType;
  token: string | null; // Okta access token OR Nextologies session
  user: any | null; // Okta claims OR Nextologies { id, airfirst_admin? }
}

const initialState: AuthState = {
  provider: null,
  token: null,
  user: null,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setAuth(state, action: PayloadAction<AuthState>) {
      state.provider = action.payload.provider;
      state.token = action.payload.token;
      state.user = action.payload.user;
    },
    clearAuth(state) {
      state.provider = null;
      state.token = null;
      state.user = null;
    },
  },
});

export const { setAuth, clearAuth } = authSlice.actions;
export default authSlice.reducer;
